<mat-form-field *ngIf="init" class="form-field" appearance="outline">
  <mat-label *ngIf="label != null">{{ label }}</mat-label>
  <mat-select
    name="selectAutocomplete"
    matInput
    [panelClass]="'taller-panel'"
    [disabled]="disabled"
    [(ngModel)]="innerValue"
    (ngModelChange)="onChangeCallback($event)"
    (openedChange)="onPanelOpen()"
    (closed)="onPanelClose()"
  >
    <mat-form-field class="inner-form-field" appearance="outline">
      <input
        #autocomplete
        matInput
        [formControl]="filterControl"
        type="text"
        name="filter-options"
        id="filter-options"
        placeholder="{{ placeholder }}"
      />
    </mat-form-field>
    <mat-option *ngFor="let option of filteredOptions" [value]="option">
      {{ displayOption(option) }}
    </mat-option>
  </mat-select>
</mat-form-field>
